module.exports = __webpack_public_path__ + "assets/CircleInAngleDetailed.6898d29eb16a79f4606b870fcb05cff9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/CircleInAngleDetailed.png
// module id = 485
// module chunks = 0